<template>
  <div class="custom-container">
    <el-container class="category-title my-2">Retur Details</el-container>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col>
              Status : 
              <span
                v-if="
                  $route.params.returDetail.returStatus ===
                  'payment_confirmation'
                "
                >Menunggu Pembayaran</span
              >
              <span
                v-else-if="$route.params.returDetail.returStatus === 'pending'"
                >Tertunda</span
              >
              <span
                v-else-if="
                  $route.params.returDetail.returStatus === 'on_progress'
                "
                >Dalam Proses</span
              >
              <span
                v-else-if="$route.params.returDetail.returStatus === 'delivery'"
                >Dalam Pengiriman</span
              >
              <span v-else-if="$route.params.returDetail.returStatus === 'done'"
                >Selesai</span
              >
            </el-col>

            <el-col>
              <el-row type="flex" justify="end">
                <el-tag v-if="$route.params.returDetail.returCreatedAt">
                  {{ $route.params.returDetail.returCreatedAt }}
                </el-tag>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="24" :md="24">
        <el-card class="box-card mb-2" shadow="never">
          <span style="font-size: 16px; font-weight: bold">Items Retur</span>
          <el-table :data="$route.params.returDetail.orderDetail" border>
            <el-table-column
              type="index"
              label="No"
              header-align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="itemName"
              label="Item"
              header-align="center"
              width="190"
            ></el-table-column>
            <el-table-column
              align="right"
              header-align="center"
              prop="itemPrice"
              label="Price"
              width="190"
            ></el-table-column>
            <el-table-column
              prop="qty"
              label="Qty"
              header-align="center"
              align="right"
              width="190"
            ></el-table-column>
          </el-table>
          <el-row class="mt-4">
            <el-col :span="17" style="text-align: right">Sub Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.subTotal }}
            </el-col>
          </el-row>
          <el-row v-if="$route.params.returDetail.titlePromoCart !== '-'">
            <el-col :span="17" style="text-align: right"
              >{{ $route.params.returDetail.titlePromoCart }} :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.totalPromoCart }}
            </el-col>
          </el-row>
          <el-row
            v-if="$route.params.returDetail.titlePromoPaymentMethod !== '-'"
          >
            <el-col :span="17" style="text-align: right"
              >{{ $route.params.returDetail.titlePromoPaymentMethod }} :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.totalPromoPaymentMethod }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right"
              >Sub Total Setelah Promo :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.subTotalAfterPromo }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right">Tax Rate :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.taxRate }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right">Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ $route.params.returDetail.total }}
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold"
              >Shipping Address</span
            >
          </el-row>
          <el-row v-if="$route.params.returDetail.ship_to">
            <template v-for="(value, name, index) in shippingAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{ $route.params.returDetail.ship_to[name] || "-" }}
              </el-col>
            </template>
          </el-row>
        </el-card>
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold">Shipping</span>
          </el-row>
          <el-row>
            <template v-for="(value, name, index) in shipping">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                  $route.params.returDetail.shipping &&
                  $route.params.returDetail.shipping[name]
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
      </el-col>

      <el-col :lg="12" :md="12">
        <el-col :lg="12" :md="12">
          <el-card
            v-if="
              $route.params.returDetail.paymentCode &&
              $route.params.returDetail.paymentCode.substring(0, 3) === 'COD'
            "
            class="mb-2"
            shadow="never"
          >
            <el-row class="mb-2">
              <span style="font-size: 16px; font-weight: bold">QR Code</span>
            </el-row>
            <el-row style="width: 100%">
              <el-row v-if="!conditionQr">
                <el-col>
                  <el-card class="qrCodeNotAvailable" shadow="never">{{
                    qrCode.data
                  }}</el-card>
                </el-col>
              </el-row>
              <el-row v-else>
                <img
                  v-if="blur"
                  src="../../assets/blurQr.png"
                  style="width: 350px; height: 350px"
                />
                <qr-code
                  v-else-if="!blur"
                  :text="qrCode.data"
                  :size="350"
                ></qr-code>
              </el-row>
              <el-button
                class="mt-4"
                type="primary"
                size="small"
                style="width: 350px"
                :loading="qrCode.isLoading"
                :disabled="disabledBtnQr"
              >
                {{
                  conditionBtn === "view" ? "View Qr Code" : "Reload Qr Code"
                }}
              </el-button>
            </el-row>
          </el-card>
          <el-card
            v-if="
              $route.params.returDetail.paymentCode &&
              $route.params.returDetail.paymentCode.substring(0, 3) === 'TOP'
            "
            class="mb-2"
            shadow="never"
          >
            <el-row class="mb-2">
              <span style="font-size: 16px; font-weight: bold">QR Code</span>
            </el-row>
            <el-row style="width: 100%">
              <el-row v-if="!conditionQr">
                <el-col>
                  <el-card class="qrCodeNotAvailable" shadow="never">{{
                    qrCode.data
                  }}</el-card>
                </el-col>
              </el-row>
              <el-row v-else>
                <img
                  v-if="blur"
                  src="../../assets/blurQr.png"
                  style="width: 350px; height: 350px"
                />
                <qr-code
                  v-else-if="!blur"
                  :text="qrCode.data"
                  :size="350"
                ></qr-code>
              </el-row>
              <el-button
                class="mt-4"
                type="primary"
                size="small"
                style="width: 350px"
                :loading="qrCode.isLoading"
                :disabled="disabledBtnQr"
              >
                {{
                  conditionBtn === "view" ? "View Qr Code" : "Reload Qr Code"
                }}
              </el-button>
            </el-row>
          </el-card>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data: () => ({
    blur: true,
    conditionBtn: "view",
    conditionQr: true,
    disabledBtnQr: false,
    formReturs: {
      paymentValue: "",
      paymentNote: "",
      attachment: ""
    },
    valid: true,
    itemsStatus: [
      { label: "Waiting for Payment", value: 0 },
      { label: "Pending", value: 1 },
      { label: "Shipping", value: 2 },
      { label: "Delivered", value: 3 },
      { label: "Rejected", value: 4 }
    ],
    image: null,
    shippingAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    billAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    shipping: {
      estimateArrival: "Estimate Arrival",
      status: "Status"
    }
  }),
  computed: {
    ...mapState({
    })
  },
  methods: {},
  watch: {},
  created() {
    this.$nextTick(() => {
      window.focus()
      window.print()
      window.close()
      this.$router.back()
    });
  }
};
</script>

<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.qrCodeNotAvailable {
  width: 350px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
}
</style>